// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/StartingPage.scss
// module id = ./src/styles/StartingPage.scss
// module chunks = 0